import styles from './Pages.module.css';

export default function Fontes(){
	return(
		<div className={styles.container}>
			<div className={styles.containerHeader}>
				<h1>Fontes</h1>
			</div>
			<div className={styles.containerContent}>
				<p>Os dados referentes ao uso e cobertura da terra da capital sergipana podem ser acessados no site do portal <a href='https://mapbiomas.org/' target="_blank" rel="noopener noreferrer">Mapbiomas Brasil</a>.</p>
				<p>Utilizou-se a coleção de dados mais recente (2021) disponibilizada na API do Mapbiomas que pode ser acessada através da plataforma Google Earth.</p>
			</div>
		</div>
	)
}